import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/media/arting-ai-qr.png")